import { ComponentPropsWithRef, ReactNode } from "react";
import { clsx } from "clsx";
import styles from "./CardGrid.module.css";

type CardGridProps = {
  children: ReactNode;
} & ComponentPropsWithRef<"div">;

export function CardGrid({ children, className, ...props }: CardGridProps) {
  return (
    <div className={clsx(styles.cardGridRoot, className)} {...props}>
      {children}
    </div>
  );
}
